import { SIDEBAR_CONTENT_ID } from 'client/constants/editorIds'
import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { SettingsNestedMenuProps } from 'src/editor/layout/sidebar/settings/settings-nested-menu'
import { SettingsNestedMenuScreen } from 'src/editor/layout/sidebar/settings/settings-nested-menu/settings-nested-menu-screen'
import {
  FormSubEntitySettingsMenuButton,
  FormSubEntitySettingsMenuButtonProps,
} from './form-sub-entity-settings-menu-button'

interface FormSubEntitiesSettingsNestedMenuItemProps
  extends Pick<SettingsNestedMenuProps, 'isOpen' | 'onClose'>,
    Pick<
      FormSubEntitySettingsMenuButtonProps,
      'hideDeleteButton' | 'onDelete' | 'skipTranslation'
    > {
  /** Already-resolved label — caller is responsible for translation. */
  title: string
  children: React.ReactNode
  icon: FormSubEntitySettingsMenuButtonProps['iconBefore']
}

export const FormSubEntitiesSettingsNestedMenuItem = ({
  title,
  skipTranslation,
  children,
  icon,
  isOpen: isOpenFromProps,
  onDelete,
  hideDeleteButton,
  onClose,
}: FormSubEntitiesSettingsNestedMenuItemProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const onBack = () => {
    setIsOpen(false)
    onClose?.()
  }
  return (
    <>
      <FormSubEntitySettingsMenuButton
        title={title}
        skipTranslation={skipTranslation}
        iconBefore={icon}
        onDelete={onDelete}
        hideDeleteButton={hideDeleteButton}
        onClick={() => setIsOpen(true)}
      />
      {(isOpenFromProps ?? isOpen) &&
        ReactDOM.createPortal(
          <SettingsNestedMenuScreen title={title} onClose={onBack}>
            {children}
          </SettingsNestedMenuScreen>,
          document.getElementById(SIDEBAR_CONTENT_ID) as HTMLElement,
        )}
    </>
  )
}
